/* global System */
// register component(s) with react habitat

export default {
  Resources: () => System.import('./Component'),
}

